// @flow
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { rgba } from 'polished';
import { getClientInf } from '../../actions/client';
import type { BuildingCounters } from '../../actions/client';
import QrButton from './QrButton';

const Header = styled.header`
  max-Width: 1020px;
  margin: auto;
  height: 194px;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 999;
`;

const Admin = styled.a`
  background: ${props => rgba(props.background, 0.5)};
  position: absolute;
  top: 20px;
  right: 10px;
  padding: 5px 10px;
  color: white;
  font-size: 12px;
  text-decoration: none;

  &:hover {
    background: ${props => rgba(props.background, 0.8)};
  }
`;

const Column = styled.div`
  padding: 0 10px;
`;

const LogoContainer = Column.extend`
  position: relative;
  flex: 2;
`;

const NavbarContainer = Column.extend`
  flex: 8;
`;

const SocialContainer = Column.extend`
  flex: 2;
  align-items: flex-end;
  display: flex;
  flex-direction: column;
`;

const SocialTitle = styled.div`
  color: #eaeaea;
  font-size: 18px;
  margin-bottom: 5px;
`;

const NavItem = styled(Link)`
  padding: 21px 20px;
  color: #eaeaea;
  text-decoration: none;
  font-size: 22px;
  text-align: center;
  cursor: pointer;

  &:hover {
    background: ${props => props.overlayColor} url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHklEQVQYV2NkYGD4z8DAwIhMgzgggCKBogKmg3iVAJgZDQNmrIUhAAAAAElFTkSuQmCC") repeat;
  }
`;

const NavItemOld = NavItem.withComponent('a');

const Menu = styled.nav`
  list-style: none;
  display: flex;
`;

const TopBanner = styled.img`
  width: 100%;
  position: absolute;
  left: -8px;
  transform: translateY(-50%);
`;

const SocialIcons = styled.div`
  color: white;
  font-size: 18px;
  text-decoration: none;
  display: flex;
  margin: 0 -5px;
`;

const SocialIcon = styled.a`
  color: white;
  text-decoration: none;
  position: relative;
  padding: 0 5px;

  &:hover:after {
    content: "${props => props.tooltip}";
    top: 110%;
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
    background: black;
    color: white;
    text-align: center;
    width: 200px;
  }
`;

const DarkBar = styled.div`
  background: rgba(0,0,0,0.5);
  width: 100%;
  display: flex;
  align-items: center;
`;

const QrIcon = SocialIcon.withComponent('span');

class Navbar extends PureComponent {
  componentDidMount() {
    this.props.getClientInf();
  }

  props: {
    getClientInf: typeof getClientInf,
    counters: BuildingCounters,
    page: Object,
    contact: Object,
  }

  render() {
    const { counters, page, contact } = this.props;
    return (
      <Header>
        {page && <Admin background={page.color_base} href="https://inmoblex.com/iniciar-sesion">ADMIN.</Admin>}
        <DarkBar>
          <LogoContainer>
            {page && page.topbanner_enabled === '1' && <TopBanner src={`http://cl.verinmuebles.com/microsite/presentation/${page.top_banner}`} />}
          </LogoContainer>
          <NavbarContainer>
            {counters && page && (
              <Menu>
                {counters.scount > 0 && <NavItem to="/propiedades-venta" overlayColor={page.color_base}>{counters.slabel}</NavItem>}
                {counters.rcount > 0 && <NavItem to="/propiedades-arriendo" overlayColor={page.color_base}>{counters.rlabel}</NavItem>}
                {counters.invcount > 0 && <NavItem to="/proyectos" overlayColor={page.color_base}>{counters.invlabel}</NavItem>}
                {counters.tcount > 0 && <NavItem to="/turismo" overlayColor={page.color_base}>{counters.tlabel}</NavItem>}
                <NavItemOld href="/contactenos" overlayColor={page.color_base}>Contáctenos</NavItemOld>
              </Menu>
            )}
          </NavbarContainer>
          <SocialContainer>
            <SocialTitle>Síguenos en:</SocialTitle>
            {contact && (
              <SocialIcons>
                {contact.facebook && <SocialIcon tooltip={contact.facebook} href={contact.facebook}><i className="icon-facebook"/></SocialIcon>}
                {contact.google_plus && <SocialIcon tooltip={contact.google_plus} href={contact.google_plus}><i className="icon-google-plus"/></SocialIcon>}
                {contact.instagram && <SocialIcon tooltip={contact.instagram} href={contact.instagram}><i className="icon-instagram"/></SocialIcon>}
                {contact.linkedin && <SocialIcon tooltip={contact.linkedin} href={contact.linkedin}><i className="icon-linkedin"/></SocialIcon>}
                {contact.twitter && <SocialIcon tooltip={contact.twitter} href={contact.twitter}><i className="icon-twitter"/></SocialIcon>}
                {contact.skype && <SocialIcon tooltip={contact.skype} href={contact.skype}><i className="icon-skype"/></SocialIcon>}
                {contact.whatsapp && <SocialIcon tooltip={contact.whatsapp} href={contact.whatsapp}><i className="icon-whatsapp"/></SocialIcon>}
                {contact.youtube && <SocialIcon tooltip={contact.youtube} href={contact.youtube}><i className="icon-youtube"/></SocialIcon>}
                <QrButton><QrIcon tooltip="Código QR para celulares"><i className="icon-qr"/></QrIcon></QrButton>
              </SocialIcons>
            )}
          </SocialContainer>
        </DarkBar>
      </Header>
    );
  }
}

export default connect(state => ({
  counters: state.client.counters,
  page: state.client.pageInfo && state.client.pageInfo.page,
  contact: state.client.pageInfo && state.client.pageInfo.contact,
}), { getClientInf })(Navbar);



// WEBPACK FOOTER //
// ./src/components/Navbar/index.js